module.exports = __webpack_public_path__ + "867025d4a46bb8394900f119de9caf8c.png";